import { Form, Loading } from '@ampol/design-system';
import React from 'react';

import CardModalAccount from '../CardModalAccount';
import useCardModalController from '../useCardModalController';
import { CardModalFormNames } from '../types/CardModalFormNames';
import useAddCardFormController from './useAddCardFormController';

interface CardModalProps {
  children?: React.ReactNode;
  formId?: string;
  onClose: () => void;
}

export default function AddCardModalForm({
  children,
  onClose,
  formId,
}: CardModalProps) {
  const addCardController = useAddCardFormController(onClose);
  const controller = useCardModalController('newCard');
  return (
    <Form
      id={formId}
      schema={controller.validationSchema}
      defaultValues={controller.defaultValues}
      onChange={controller.onFormChange}
      onSubmit={addCardController.onFormSubmit}
      memoizeDefaultValues={false}
    >
      <div className="space-y-xl">
        <CardModalAccount />
        <Form.Condition
          fieldName={CardModalFormNames.Account}
          condition={(value) => !!value}
        >
          {addCardController.isLoading && <Loading type="indeterminate" />}
          {!addCardController.isLoading && children}
        </Form.Condition>
      </div>
    </Form>
  );
}
